import { 
	GET_ALL_PROJECT_DRAWING_OFFICE_WORK_PACKAGES,
	GET_MY_WORKPACKAGES_PROJECT_DRAWING_OFFICE_WORK_PACKAGES,
	GET_PROJECT_DRAWING_OFFICE_WORK_PACKAGES, 
	GET_PROJECT_DRAWING_OFFICE_WORK_PACKAGE,
	CREATE_PROJECT_DRAWING_OFFICE_WORK_PACKAGE,
	UPDATE_PROJECT_DRAWING_OFFICE_WORK_PACKAGE,
	DESTROY_PROJECT_DRAWING_OFFICE_WORK_PACKAGE,
} from "./actions"
import { GET_COMMENTS, CREATE_COMMENT, MARK_COMMENTS_READ } from "modules/comments/actions"

const WORK_PACKAGE_TYPE = "Project::DrawingOffice::WorkPackage";

function clearUnreadComments(state, action) {
	const { commentableType, commentableId } = action.meta || {};
	if (commentableType !== WORK_PACKAGE_TYPE || commentableId == null) return state;

	const key = _.findKey(state, (item) => String(item.id) === String(commentableId));
	if (!key || !state[key].unread_comments_count) return state;

	const newState = _.clone(state);
	newState[key] = { ...state[key], unread_comments_count: 0 };
	return newState;
}

export function ProjectDrawingOfficeWorkPackagesReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_DRAWING_OFFICE_WORK_PACKAGES}_FULFILLED`:
		case `${GET_ALL_PROJECT_DRAWING_OFFICE_WORK_PACKAGES}_FULFILLED`:
		case `${GET_MY_WORKPACKAGES_PROJECT_DRAWING_OFFICE_WORK_PACKAGES}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_DRAWING_OFFICE_WORK_PACKAGE}_FULFILLED`:
		case `${CREATE_PROJECT_DRAWING_OFFICE_WORK_PACKAGE}_FULFILLED`:
		case `${UPDATE_PROJECT_DRAWING_OFFICE_WORK_PACKAGE}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_DRAWING_OFFICE_WORK_PACKAGE}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		case `${GET_COMMENTS}_FULFILLED`:
		case `${CREATE_COMMENT}_FULFILLED`:
		case `${MARK_COMMENTS_READ}_FULFILLED`:
			return clearUnreadComments(state, action);
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectDrawingOfficeWorkPackagesReducer } from "modules/project/drawing_office/work_packages/reducer"

// project_drawing_office_work_packages:ProjectDrawingOfficeWorkPackagesReducer,
